// Decorative CRT scanlines + vignette. Purely cosmetic, pointer-events: none.
export function CrtOverlay({ on }: { on: boolean }) {
  if (!on) return null;
  return (
    <>
      <div
        style={{
          position: "fixed",
          inset: 0,
          pointerEvents: "none",
          zIndex: 9998,
          background:
            "repeating-linear-gradient(rgba(0,0,0,0) 0px,rgba(0,0,0,0) 2px,rgba(0,0,0,.16) 3px)",
          mixBlendMode: "multiply",
        }}
      />
      <div
        style={{
          position: "fixed",
          inset: 0,
          pointerEvents: "none",
          zIndex: 9997,
          background:
            "radial-gradient(120% 120% at 50% 40%,transparent 55%,rgba(0,0,0,.55) 100%)",
        }}
      />
    </>
  );
}
